export const isAdventureComplete = (
  dateStart: string,
  dateEnd?: string | null,
  now = new Date(),
) => {
  const completionDate = new Date(`${dateEnd ?? dateStart}T23:59:59.999`);
  return now.getTime() > completionDate.getTime();
};

export const canPostAdventureMemory = (
  userId?: string | null,
  organiserId?: string | null,
  membershipStatus?: string | null,
  complete?: boolean,
) => {
  if (!complete || !userId) {
    return false;
  }

  return userId === organiserId || membershipStatus === 'joined';
};

export const getAdventureMemoryGuidance = (
  complete: boolean,
  canPost: boolean,
  hasMemories: boolean,
  hasDefaultImage: boolean,
) => {
  if (!complete) {
    return 'Memories open the day after this activity ends.';
  }

  if (canPost) {
    return hasDefaultImage
      ? 'Add a caption and Kindred will use the activity photo unless you upload a new one.'
      : 'Add a caption to save a memory from this activity.';
  }

  if (hasMemories) {
    return 'Memories stay on this activity page so families can revisit them later.';
  }

  return 'Joined members can add memories here once the activity has finished.';
};
